module.exports = __webpack_public_path__ + "img/icon-logout-active.5706b59a.svg";